import { h, Component } from 'preact';
import linkState from 'linkstate';
import { route } from 'preact-router';

import getStore from '../../../store';
import * as InquiriesActions from '../../../reducers/inquiries/inquiries.actions';

import { ReqState } from '../../../../../types/request-state.model';
import { InquiryDocument } from '../../../../../types/inquiries/inquiry-document.model';

import { HopplerModalizer } from '../../common/hoppler-modalizer.component';
import { OFFER_SENT_STATUSES } from '../../../../../constants/inquiries';

interface InqOfferSentModalProps {
  documentChoices: InquiryDocument[];
  offerReqState: ReqState;

  onClose: () => void;
  onUploadClick: (document: InquiryDocument, status: string) => void;

  submitState: ReqState;
}

interface InqOfferSentModalState {
  selectedLoiKey?: string;
  selectedStatus?: string;
}

const store = getStore();

export class InqOfferSentModal extends Component<InqOfferSentModalProps, InqOfferSentModalState> {
  constructor(props) {
    super(props);
  }

  handleLoiUpload = (e) => {
    e.preventDefault();
    const selectedLoi = this.props.documentChoices.find(doc => doc.loiKey === this.state.selectedLoiKey);

    this.props.onUploadClick(
      selectedLoi,
      this.state.selectedStatus
    );
  }

  // onFileSelect(event: Event) {
  //   const target = event.target as HTMLInputElement;

  //   if (target.files.length > 0) {
  //     this.setState({ selectedFiles: target.files });
  //     console.log('Selected files:', target.files);
  //   }
  // }

  doesInquiryHaveOffers() {
    const { offerReqState, documentChoices } = this.props;

    if (offerReqState === ReqState.SUCCESS) {
      return documentChoices.length > 0;
    }
  }

  onProceedToNextStage(stageSlug: string) {
    route(`/kumita-brokers/inquiries/${stageSlug}?actionFrom=upload-offer-sent`);
    this.props.onClose();
  }

  onTransitionCloseClick() {
    store.dispatch(InquiriesActions.loadAllStages());
    this.props.onClose();
  }

  //////////////////////////////////////////////////////////////////////////////
  // Validations
  //////////////////////////////////////////////////////////////////////////////

  isUploadButtonEnabled() {
    const { selectedStatus } = this.state;
    const formValid = !!(selectedStatus);
    const reqInProgress = this.props.submitState === ReqState.IN_PROGRESS

    return formValid && !reqInProgress;
  }


  //////////////////////////////////////////////////////////////////////////////
  // Conditional UI
  //////////////////////////////////////////////////////////////////////////////

  getOfferSelectionGroup() {
    const { documentChoices, offerReqState } = this.props;
    
    if (offerReqState === ReqState.SUCCESS) {
      if (documentChoices.length > 0) {
        return (
          <div className="hi-inqloiupload__upload-body-field">
            <label className="hi-input-group__label">Select an offer</label>
            {/* <input className="form-control" disabled value={ document.documentName || document.propertyAddress } /> */}
            <select className="form-control" onChange={ linkState(this, 'selectedLoiKey') } value={ this.state.selectedLoiKey }>
              { documentChoices.map(choice => (
                <option value={ choice.loiKey }>{ choice.documentName || choice.propertyAddress }</option>
              )) }
            </select>
          </div>
        );
      } else {
        return (
          <p className="mb-0">
            <strong className="text-danger d-block mb-2">This inquiry has no existing offers.</strong>
            Please create an offer before marking an offer as sent.
          </p>
        )
      }
    } else {
      return (
        <div className="hi-inqloiupload__upload-body-field">
          <label className="hi-input-group__label">Select an LOI</label>
          <input type="text" className="form-control" disabled placeholder="Loading offers for this inquiry..." />
        </div>
      );
    }
  }

  getSuccessContent() {
    // const files = this.state.selectedFiles;
    // const hasFiles = files && files.length > 0;
    // const targetStageName = hasFiles ? 'Offer Accepted' : 'Offer Sent';
    // const targetStageSlug = hasFiles ? 'offer-accepted' : 'offer-sent';

    return (
      <div className="hi-inqloiupload__success">
        <p className="hi-inqloiupload__success-title">Successful Upload</p>
        <p>Inquiry will be moved under Offer Sent stage.</p>
        <button className="btn btn-block btn-secondary mt-4" onClick={ () => this.onProceedToNextStage('offer-sent') }>
          Proceed to Offer Sent
        </button>
        <button className="btn btn-block btn-outline-dark mt-4" onClick={ () => this.onTransitionCloseClick() }>
          Back
        </button>
      </div>
    )
  }

  getForm(props: InqOfferSentModalProps, state: InqOfferSentModalState) {
    return (
      <form onSubmit={ this.handleLoiUpload } >
        { this.getOfferSelectionGroup() }

        <div className="hi-input-group">
          <label className="hi-input-group__label">Status</label>
          <select className="form-control" value={ state.selectedStatus }
            onChange={ linkState(this, 'selectedStatus') }>
            { OFFER_SENT_STATUSES.map(status => (
              <option value={ status }>{ status }</option>
            ))}
          </select>
        </div>

        <div className="text-center">
          <button
            type="submit"
            disabled={ !this.isUploadButtonEnabled() }
            className="btn btn-secondary upload-btn">
              { props.submitState === ReqState.IN_PROGRESS ? 'Uploading...' : 'Upload' }
          </button>
        </div>
      </form>
    )
  }

  render(props: InqOfferSentModalProps, state: InqOfferSentModalState) {
    return <HopplerModalizer onClose={ () => null }>
      <section className="hi-inqloiupload">
        <div className="hi-inqloiupload__upload-header">
          <p className="title">Mark Offer as Sent</p>
          <button
            onClick={ props.onClose } 
            className="close-btn btn btn-default">
            <i className="fas fa-times fa-fw mr-1"></i>
            Close
          </button>
        </div>

        <div className="hi-inqloiupload__upload-body">
          {
            !(props.submitState === ReqState.SUCCESS)
              ? this.getForm(props, state)
              : this.getSuccessContent()
          }
        </div>

      </section>
    </HopplerModalizer>
  }

  componentWillReceiveProps(nextProps: InqOfferSentModalProps) {
    if (nextProps.documentChoices && nextProps.documentChoices.length > 0 && !this.props.documentChoices) {
      const numDocs = nextProps.documentChoices.length;
      const latestDoc = nextProps.documentChoices[numDocs - 1];
      this.setState({
        selectedLoiKey: latestDoc.loiKey
      });
    }
  }
}